import React from 'react';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  message: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: ({ id }) => (id && 8)
  },
  icon: {
    marginRight: theme.spacing(2)
  },
  content: {
    marginLeft: ({ id }) => (id && 40)
  }
}));


const ToastMessage = ({ content, Icon, id }) => {
  const classes = useStyles({ id });

  return (
    <>
      <div className={classes.message}>
        <Icon className={classes.icon} />
        {id ? (
          <div>
            <span>Error id: </span>
            <strong>{id}</strong>
          </div>
        ) : <div className={classes.content}>{content}</div>}
      </div>
      {id && <div className={classes.content}>{content}</div>}
    </>
  );
};

ToastMessage.propTypes = {
  Icon: PropTypes.object,
  content: PropTypes.string,
  id: PropTypes.string
};

export default ToastMessage;
